// misc JS for steps/tasks

import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['editable']

  editMe(event) {
    // Turn all editable parts back to 'viewing' state
    var editable_parts = this.editableTargets
    for (let editable_part of editable_parts) {
      editable_part.classList.remove("editing");
      editable_part.classList.add("viewing");
    }

    // Hide/reset all configurations (block content, automations) forms
    resetConfigurationForms(this.element);

    // Turn THIS editable part to 'editing' state
    var edit_me = event.target.closest("[data-target*='step--step.editable']");
    edit_me.classList.add("editing");
    edit_me.classList.remove("viewing");

    // Populate the form field with the current title
    var titleElement = edit_me.querySelector("h2");
    var titleInput = edit_me.querySelector("input.step-title");
    
    if (titleElement && titleInput) {
      // Get the text content from the h2 element (without HTML tags)
      var currentTitle = titleElement.textContent || titleElement.innerText;
      // Trim any leading/trailing whitespace to prevent unwanted spaces
      titleInput.value = currentTitle.trim();
      
      // Focus the input field
      setTimeout(function() {
        titleInput.focus();
        titleInput.select(); // Select all text for easy editing
      }, 100);
    }
  }

  focusMe(event) {
    var block = event.target.closest(".block");
    var block_id = block.dataset.blockId;
    var input = this.element.querySelector(".block-"+block_id+"-input");
    var rich_text_modal = event.target.closest(".trix-dialog");
    var rich_text_button = event.target.closest("button[data-trix-action='link']");

    if (!rich_text_modal) {

      // focus the input
      if (input && !rich_text_button) {
        input.focus();
      }

      // unfocus any other blocks that are currently focused
      var focused_blocks = this.element.querySelectorAll(".block.focused");
      for (let focused_block of focused_blocks) {
        focused_block.classList.remove("focused");
      }
      // focus this block
      block.classList.add("focused");
    }
  }

  updateClose(event){
    event.preventDefault();

    var step = event.target.closest(".step");
    var task_id = step.dataset.taskId;
    var form = event.target.closest("form.step-content-form");

    var current_step_status = step.dataset.stepExpanderStatus;
    var is_expanded = current_step_status === "expanded" || step.classList.contains("expanded");
    
    if (task_id) {
      localStorage.setItem(`task:${task_id}:expanded`, is_expanded ? "true" : "false");
    }

    Rails.fire(form, 'submit');
  }

  submitConfigureBlock(event) {
    var block_id = event.target.dataset.blockId;
    var form = event.target.closest("form.step-content-form");
    var form_action = form.action;
    var step = form.closest(".step");
    var task_id = step ? step.dataset.taskId : null;
    
    if (task_id) {
      localStorage.setItem(`task:${task_id}:expanded`, "true");
      var new_form_action_url = form_action + "?configured_block_id=" + block_id + "&task_expanded=true";
      form.action = new_form_action_url;
    } else {
    var new_form_action_url = form_action + "?configured_block_id=" + block_id;
      form.action = new_form_action_url;
    }
  }
  
  handleFormSubmit(event) {
    var form = event.target;
    var configured_block_id = form.querySelector('input[name="configured_block_id"]');
    var step = form.closest(".step");
    var task_id = step ? step.dataset.taskId : null;
    
    if (configured_block_id && configured_block_id.value && task_id) {
      localStorage.setItem(`task:${task_id}:expanded`, "true");
      
      if (!form.action.includes("task_expanded")) {
        var separator = form.action.includes("?") ? "&" : "?";
        form.action = form.action + separator + "task_expanded=true";
      }
    }
  }

  viewMe(event) {
    var editable_part = event.target.closest("[data-target*='step--step.editable']");
    editable_part.classList.add("viewing");
    editable_part.classList.remove("editing");
  }

  viewAll() {
    var editable_parts = this.editableTargets
    for (let editable_part of editable_parts) {
      editable_part.classList.remove("editing");
      editable_part.classList.add("viewing");
    }
    var focused_fields = this.element.querySelectorAll(".focused");
    for (let focused_field of focused_fields) {
      focused_field.classList.remove("focused");
    }
  }

  resetAllConfigurationForms() {
    // Hides/resets all configurations forms
    resetConfigurationForms(this.element);
  }

  uppyClick(event) {
    const target = event.target;
    if (!target) return;

    const blockId = target.dataset.blockId;

    const blockElement = Array
      .from(document.querySelectorAll(`[data-block-id="${blockId}"]`))
      .find(el => el.offsetParent !== null);

    if (!blockElement) return;

    const filesAttached =
      blockElement.getAttribute("data-files-attached") === "true";

    const uppyModal = blockElement.querySelector(`#uppyModal-${blockId}`);
    const uppyContainer = blockElement.querySelector(`#uppy-${blockId}`);
    const container = blockElement.querySelector(`.block-${blockId}`);
    const upload_action = container.getAttribute("data-upload-action");

    if (!filesAttached) {
      uppyModal.style.display = "flex";

      // ✅ BACKDROP click only
      uppyModal.onclick = (e) => {
        if (e.target === uppyModal) {
          uppyModal.style.display = "none";
          uppyContainer.innerHTML = "";
        }
      };

      // ✅ PREVENT clicks inside modal from closing it
      uppyContainer.addEventListener("click", e => {
        e.stopPropagation();
      });

      if (!this[`uppy_${blockId}`]) {
        this[`uppy_${blockId}`] = this.initializeUppyModal(
          blockElement,
          blockId,
          upload_action
        );
      }
    }
  }


  initializeUppyModal(blockElement, blockId, upload_action) {
    const container = blockElement.querySelector(`.block-${blockId}`);
    const userId = container.getAttribute("data-user-id");
    const accountId = container.getAttribute("data-account-id");
    const projectId = container.getAttribute("data-project-id");
    const taskListId = container.getAttribute("data-task-list-id");
    const taskId = container.getAttribute("data-task-id");
    let companionUrl = process.env.COMPANION_URL;
    if (!companionUrl) {
      const companionMeta = document.querySelector('meta[name="companion-url"]');
      if (companionMeta) {
        companionUrl = companionMeta.getAttribute('content');
      }
    }
    
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const uppyEndpoint = `/${accountId}/projects/${projectId}/task_lists/${taskListId}/tasks/${taskId}/task_blocks/${blockId}/attach_more_files`;
    const upload_method = "POST";
    
    console.log('🔧 Uppy endpoint configured:', uppyEndpoint);

    const uppyConfig = {
      restrictions: {
        maxNumberOfFiles: null,
        maxFileSize: 100 * 1024 * 1024, // 100 MB in bytes
      },
      meta: {
        'user_id': userId,
        'account_id': accountId,
      },
      allowMultipleUploads: true, 
    };

    if (companionUrl && companionUrl.trim() !== '') {
      uppyConfig.companionUrl = companionUrl;
    }

    const uppy = new window.Uppy(uppyConfig);

    uppy.use(window.ImageEditor);
    uppy.use(window.Webcam);
    uppy.use(window.UppyAudio);
    
   
    const driveConfig = companionUrl && companionUrl.trim() !== '' ? { companionUrl } : {};
    uppy.use(window.GoogleDrive, driveConfig);
    uppy.use(window.Dropbox, driveConfig);

    const uppyContainer = blockElement.querySelector(
      `[id="uppy-${blockId}"]`
    );

    uppy.use(window.Dashboard, {
      inline: true,
      target: uppyContainer,
      showProgressDetails: true,
      proudlyDisplayPoweredByUppy: false,
    });

    uppyContainer?.addEventListener("click", e => {
      e.stopPropagation();
    });

    uppy.on('file-added', (file) => {
      const isRemote = file.isRemote;

      const XHRUploadOptions = {
        endpoint: uppyEndpoint,
        method: upload_method,
        formData: true,
        fieldName: "task_block[files][]",
        headers: {
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json',
        },
        params: uppy.getState().meta,
        bundle: !isRemote,
        getResponseData: (responseText) => {
          console.log('🔧 getResponseData - responseText type:', typeof responseText);
          console.log('🔧 getResponseData - responseText:', typeof responseText === 'string' ? responseText.substring(0, 500) : responseText);
          try {
            if (typeof responseText === 'string' && (responseText.startsWith("{") || responseText.startsWith("["))) {
              const parsed = JSON.parse(responseText);
              console.log('✅ Parsed JSON keys:', Object.keys(parsed));
              console.log('✅ Parsed JSON has js_code?', !!parsed.js_code);
              console.log('✅ Full parsed JSON:', JSON.stringify(parsed, null, 2));
              return parsed;
            }
            console.warn('⚠️ responseText is not JSON string');
            return { success: true };
          } catch (error) {
            console.error('❌ Error parsing response:', error);
            console.error('❌ responseText that failed:', typeof responseText === 'string' ? responseText.substring(0, 500) : responseText);
            return { success: true };
          }
        },
      }
      uppy.use(window.XHRUpload, XHRUploadOptions)
    })

    uppy.on('complete', (result) => {
      console.log('🔧 Upload complete:', result);

      if (result.failed.length > 0) {
        console.error('Upload failed! Files:', result.failed);
        result.failed.forEach((file) => {
          console.error('Failed file:', file.error);
        });
      }

      if (result.successful.length > 0) {
        console.log('✅ All files uploaded successfully');

        const uppyModal = blockElement.querySelector(`#uppyModal-${blockId}`);
        if (uppyModal) {
          uppyModal.style.display = 'none';
        }

        if (uppyContainer) {
          uppyContainer.innerHTML = '';
        }

        if (this[`uppy_${blockId}`]) {
          this[`uppy_${blockId}`] = null;
        }

        this.updateBlockContentAfterUpload(blockId, taskId, taskListId, accountId, projectId);
      } else {
        console.warn('⚠️ No successful uploads to process');
      }
    });

    uppy.on('error', (error) => {
      console.error('Uppy encountered an error:', error);
    });
  }

  openModalFromPreview(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const fileUrl = event.currentTarget.getAttribute("data-file-url");
    const fileType = event.currentTarget.getAttribute("data-file-type");
    const fileId = event.currentTarget.getAttribute("data-file-id");

    console.log('🚀 Stimulus controller triggered:', { fileUrl, fileType, fileId });

    // Check if modal elements exist
    const root = event.currentTarget.closest(
      ".compact-process-view, .process"
    );

    const modal = root?.querySelector(`[id="file-modal-${fileId}"]`);
    const modalContent = root?.querySelector(
      `[id="modal-preview-content-${fileId}"]`
    );

    console.log('📋 Modal elements found:', { modal, modalContent });

    if (!modal || !modalContent) {
      console.error('❌ Modal elements not found!', { modal, modalContent });
      return;
    }

    this.openModal(fileUrl, fileType, fileId, root);

    // Attach click-to-close on backdrop (once)
    modal.addEventListener("click", (e) => this.closeModal(e, fileId), { once: true });

    // Prevent modal close when clicking inside content
    modalContent.addEventListener("click", (e) => e.stopPropagation(), { once: true });

    // Remove any existing ESC handler
    if (modal._escHandler) {
      document.removeEventListener("keydown", modal._escHandler);
      delete modal._escHandler;
    }

    // Attach ESC key listener
    const escKeyHandler = (e) => {
      if (e.key === "Escape") {
        this.closeModal(null, fileId);
      }
    };
    document.addEventListener("keydown", escKeyHandler);
    modal._escHandler = escKeyHandler;

    // Store the handler reference for cleanup
    modal.dataset.escHandler = 'true';
  }

  openModal(fileUrl, fileType, fileId, root) {
    const modal = root?.querySelector(
      `[id="file-modal-${fileId}"]`
    );

    const modalContent = root?.querySelector(
      `[id="modal-preview-content-${fileId}"]`
    );

    if (!modal || !modalContent) {
      console.error("❌ Modal elements not found in scoped view", {
        fileId,
        root
      });
      return;
    }

    modal.style.display = "flex";
    document.body.style.overflow = "hidden";

    // Clear content (we'll add close button later for PDFs)
    modalContent.innerHTML = "";

    console.log('✅ Modal content cleared');

    // Create content container
    const contentContainer = document.createElement("div");
    contentContainer.className = "file-modal-content";

    if (fileType.startsWith("image")) {
      // Add close button to modal content
      // const modalCloseButton = document.createElement("button");
      // modalCloseButton.innerHTML = "&times;";
      // modalCloseButton.className = "file-modal-close";
      // modalCloseButton.setAttribute("aria-label", "Close");
      // modalCloseButton.setAttribute("data-file-id", fileId);
      // modalCloseButton.addEventListener("click", (event) => {
      //   event.stopPropagation();
      //   this.closeModal(event, fileId);
      // });
      
      // modalContent.appendChild(modalCloseButton);
      
      contentContainer.innerHTML = `<img src="${fileUrl}" class="modal-image" />`;
    } else if (fileType === "application/pdf") {
      // Create outer container for the entire PDF preview with white border
      const pdfOuterContainer = document.createElement('div');
      pdfOuterContainer.className = 'pdf-outer-container';
      pdfOuterContainer.style.cssText = `
        position: relative;
        width: 100%;
        height: 80vh;
        border: 2px solid #ddd;
        border-radius: 8px;
        background: white;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        overflow: hidden;
      `;
      
      // // Create close button positioned on the white bordered container
      // const containerCloseButton = document.createElement('button');
      // containerCloseButton.innerHTML = '&times;';
      // containerCloseButton.className = 'pdf-container-close-button';
      // containerCloseButton.setAttribute('aria-label', 'Close PDF');
      // containerCloseButton.setAttribute('data-file-id', fileId);
      // containerCloseButton.style.cssText = `
      //   position: absolute;
      //   top: 5px;
      //   right: 120px;
      //   background: rgba(0, 0, 0, 0.8);
      //   color: white;
      //   border: none;
      //   border-radius: 50%;
      //   width: 35px;
      //   height: 35px;
      //   font-size: 18px;
      //   font-weight: bold;
      //   cursor: pointer;
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      //   z-index: 1000;
      //   transition: all 0.2s ease;
      //   box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
      // `;
      
      // // Add hover effects
      // containerCloseButton.addEventListener('mouseenter', () => {
      //   containerCloseButton.style.background = 'rgba(0, 0, 0, 0.9)';
      //   containerCloseButton.style.transform = 'scale(1.1)';
      // });
      
      // containerCloseButton.addEventListener('mouseleave', () => {
      //   containerCloseButton.style.background = 'rgba(0, 0, 0, 0.8)';
      //   containerCloseButton.style.transform = 'scale(1)';
      // });
      
      // // Close button functionality
      // containerCloseButton.addEventListener('click', (event) => {
      //   event.stopPropagation();
      //   this.closeModal(event, fileId);
      // });
      
      // Create PDF embed
      const pdfEmbed = document.createElement('embed');
      pdfEmbed.src = fileUrl;
      pdfEmbed.type = 'application/pdf';
      pdfEmbed.className = 'pdf-preview';
      pdfEmbed.style.cssText = 'width: 100%; height: 100%; border: none;';

      // Assemble the containers
      // pdfOuterContainer.appendChild(containerCloseButton);
      pdfOuterContainer.appendChild(pdfEmbed);

      contentContainer.appendChild(pdfOuterContainer);
      console.log('✅ PDF embed created with container close button');
    } else if (fileType.startsWith("video")) {
      const loadingIndicator = document.createElement('div');
      loadingIndicator.className = 'video-loading-indicator';
      loadingIndicator.style.cssText = `
        padding: 40px;
        text-align: center;
        color: #666;
        font-size: 16px;
      `;
      loadingIndicator.innerHTML = `
        <div style="margin-bottom: 10px;">
          <div class="spinner" style="border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto;"></div>
        </div>
        <p>Loading video...</p>
      `;
      contentContainer.appendChild(loadingIndicator);
      
      const videoElement = document.createElement('video');
      videoElement.controls = true;
      videoElement.src = fileUrl;
      videoElement.className = 'modal-video';
      videoElement.style.cssText = 'width: 100%; max-width: 100%; height: auto; max-height: 80vh; display: none;';
      videoElement.preload = 'auto';
      
      if (fileType.includes('mpeg') || fileType.includes('mpg')) {
        videoElement.type = 'video/mpeg';
      } else if (fileType.includes('mp4')) {
        videoElement.type = 'video/mp4';
      } else if (fileType.includes('webm')) {
        videoElement.type = 'video/webm';
      }
      
      let loadingTimeout;
      const showError = (message) => {
        clearTimeout(loadingTimeout);
        contentContainer.innerHTML = '';
        const errorMsg = document.createElement('div');
        errorMsg.className = 'video-error-message';
        errorMsg.style.cssText = 'padding: 40px; text-align: center; color: #666;';
        errorMsg.innerHTML = `
          <p style="font-size: 18px; margin-bottom: 10px; color: #d32f2f;">⚠️ ${message}</p>
          <p style="margin-bottom: 20px;">The video format may not be supported by your browser.</p>
          <p><a href="${fileUrl}" download style="color: #007bff; text-decoration: underline; font-weight: bold;">Download the file instead</a></p>
        `;
        contentContainer.appendChild(errorMsg);
      };
      
      videoElement.addEventListener('error', (e) => {
        console.error('Video playback error:', e, videoElement.error);
        const errorCode = videoElement.error ? videoElement.error.code : 'unknown';
        let errorMessage = 'Unable to play this video file.';
        
        if (errorCode === 4) {
          errorMessage = 'Video format not supported by your browser.';
        } else if (errorCode === 3) {
          errorMessage = 'Video decoding error. The file may be corrupted.';
        } else if (errorCode === 2) {
          errorMessage = 'Network error while loading video.';
        }
        
        showError(errorMessage);
      });
      
      videoElement.addEventListener('loadeddata', () => {
        clearTimeout(loadingTimeout);
        loadingIndicator.remove();
        videoElement.style.display = 'block';
        console.log('Video loaded successfully');
      });
      
      videoElement.addEventListener('canplay', () => {
        clearTimeout(loadingTimeout);
        if (loadingIndicator.parentNode) {
          loadingIndicator.remove();
        }
        videoElement.style.display = 'block';
        console.log('Video can start playing');
      });
      
      loadingTimeout = setTimeout(() => {
        if (videoElement.readyState < 2) { // HAVE_CURRENT_DATA
          console.warn('Video loading timeout');
          showError('Video is taking too long to load. The file format may not be supported.');
        }
      }, 30000);
      
      contentContainer.appendChild(videoElement);
      
      if (!document.getElementById('video-spinner-style')) {
        const style = document.createElement('style');
        style.id = 'video-spinner-style';
        style.textContent = `
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `;
        document.head.appendChild(style);
      }
    } else if (fileType.startsWith("audio")) {
      contentContainer.innerHTML = `<audio controls src="${fileUrl}" class="modal-audio" style="width: 100%; max-width: 400px; height: 50px;" />`;
    } else if (fileType.startsWith("text/")) {
      // Add close button to modal content for text files
      const modalCloseButton = document.createElement("button");
      modalCloseButton.innerHTML = "&times;";
      modalCloseButton.className = "file-modal-close text-file-close-button";
      modalCloseButton.setAttribute("aria-label", "Close");
      modalCloseButton.setAttribute("data-file-id", fileId);
      modalCloseButton.style.cssText = `
        position: absolute;
        top: 20px;
        right: 20px;
        background: rgba(0, 0, 0, 0.8);
        color: white;
        border: none;
        border-radius: 50%;
        width: 35px;
        height: 35px;
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        transition: all 0.2s ease;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
      `;
      
      // Add hover effects
      modalCloseButton.addEventListener('mouseenter', () => {
        modalCloseButton.style.background = 'rgba(0, 0, 0, 0.9)';
        modalCloseButton.style.transform = 'scale(1.1)';
      });
      
      modalCloseButton.addEventListener('mouseleave', () => {
        modalCloseButton.style.background = 'rgba(0, 0, 0, 0.8)';
        modalCloseButton.style.transform = 'scale(1)';
      });
      
      modalCloseButton.addEventListener("click", (event) => {
        event.stopPropagation();
        this.closeModal(event, fileId);
      });
      
      // modalContent.appendChild(modalCloseButton);
      
      // Create text container
      const textContainer = document.createElement('div');
      textContainer.className = 'text-file-container';
      textContainer.style.cssText = `
        width: 100%;
        height: 90vh;
        border: 2px solid #ddd;
        border-radius: 8px;
        background: white;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        overflow: hidden;
        position: relative;
      `;
      
      // Create text content area
      const textContent = document.createElement('pre');
      textContent.className = 'text-file-content';
      textContent.style.cssText = `
        width: 100%;
        height: 100%;
        padding: 60px 20px 20px 20px;
        margin: 0;
        font-family: 'Courier New', monospace;
        font-size: 14px;
        line-height: 1.5;
        background: white;
        color: #333;
        overflow: auto;
        white-space: pre-wrap;
        word-wrap: break-word;
      `;
      
      // Fetch and display text content
      fetch(fileUrl)
        .then(response => response.text())
        .then(text => {
          textContent.textContent = text;
          console.log('✅ Text file content loaded');
        })
        .catch(error => {
          console.error('Error loading text file:', error);
          textContent.textContent = 'Error loading file content. Please try downloading the file.';
        });
      
      textContainer.appendChild(textContent);
      contentContainer.appendChild(textContainer);
      
      console.log('✅ Text file preview created');
    } else if (
      fileType === "application/msword" ||
      fileType ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      // Create document container with proper positioning
      const docContainer = document.createElement("div");
      docContainer.className = "doc-preview-container";
      docContainer.style.cssText = `
        position: relative;
        width: 100%;
        height: 90vh;
        border: 2px solid #ddd;
        border-radius: 8px;
        background: white;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        overflow: hidden;
      `;
      
      // Add close button to document container
      // const docCloseButton = document.createElement("button");
      // docCloseButton.innerHTML = "&times;";
      // docCloseButton.className = "doc-close-button";
      // docCloseButton.setAttribute("aria-label", "Close");
      // docCloseButton.setAttribute("data-file-id", fileId);
      // docCloseButton.style.cssText = `
      //   position: absolute;
      //   top: 10px;
      //   right: 10px;
      //   background: rgba(0, 0, 0, 0.8);
      //   color: white;
      //   border: none;
      //   border-radius: 50%;
      //   width: 35px;
      //   height: 35px;
      //   font-size: 18px;
      //   font-weight: bold;
      //   cursor: pointer;
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      //   z-index: 1000;
      //   transition: all 0.2s ease;
      //   box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
      // `;
      
      // Add hover effects
      // docCloseButton.addEventListener('mouseenter', () => {
      //   docCloseButton.style.background = 'rgba(0, 0, 0, 0.9)';
      //   docCloseButton.style.transform = 'scale(1.1)';
      // });
      
      // docCloseButton.addEventListener('mouseleave', () => {
      //   docCloseButton.style.background = 'rgba(0, 0, 0, 0.8)';
      //   docCloseButton.style.transform = 'scale(1)';
      // });
      
      // docCloseButton.addEventListener("click", (event) => {
      //   event.stopPropagation();
      //   this.closeModal(event, fileId);
      // });
      
      // Create document preview container
      const docxContainer = document.createElement("div");
      docxContainer.id = `doc-preview-${fileId}`;
      docxContainer.style.cssText = `
        width: 100%;
        height: 100%;
        padding: 1px;
        overflow: auto;
      `;
      
      // Assemble the containers
      // docContainer.appendChild(docCloseButton);
      docContainer.appendChild(docxContainer);
      contentContainer.appendChild(docContainer);
      
      // Fetch and render the document
      fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        var options = {
            inWrapper: true,
            ignoreWidth: false,
            ignoreHeight: false,
            breakPages: false,
          };
          docx
            .renderAsync(blob, docxContainer, null, options)
            .then(() => console.log("DOCX preview rendered with close button"))
            .catch((err) => console.error("Error rendering DOCX:", err));
        })
        .catch((error) => console.error("Error fetching DOCX file:", error));
    } else if (
      fileType === "application/vnd.ms-excel" ||
      fileType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      // Wrap Excel preview in a container with iframe-like styling
      const excelContainer = document.createElement("div");
      excelContainer.id = `doc-preview-${fileId}`;
      contentContainer.appendChild(excelContainer);
      new ExcelViewer(excelContainer, fileUrl, {
        theme: "white",
        lang: "en",
      });
    } else {
      contentContainer.innerHTML = `<p>Preview not available. <a href="${fileUrl}" target="_blank">Download File</a></p>`;
    }

    modalContent.appendChild(contentContainer);
  }

  addCloseButtonToPdfToolbar(fileId) {
    // Try multiple times with increasing delays
    const attempts = [500, 1000, 2000, 3000];
    
    attempts.forEach((delay, index) => {
      setTimeout(() => {
        try {
          console.log(`Attempt ${index + 1} to add close button (delay: ${delay}ms)`);
          
          // Find the PDF viewer
          const pdfViewer = document.querySelector('pdf-viewer');
          if (!pdfViewer) {
            console.log('PDF viewer not found');
            return;
          }
          console.log('PDF viewer found:', pdfViewer);

          // Access the shadow DOM
          const shadowRoot = pdfViewer.shadowRoot;
          if (!shadowRoot) {
            console.log('PDF viewer shadow root not found');
            return;
          }
          console.log('PDF viewer shadow root found:', shadowRoot);

          // Find the viewer-toolbar
          const viewerToolbar = shadowRoot.querySelector('viewer-toolbar');
          if (!viewerToolbar) {
            console.log('viewer-toolbar not found');
            return;
          }
          console.log('viewer-toolbar found:', viewerToolbar);

          // Access the viewer-toolbar's shadow DOM
          const toolbarShadowRoot = viewerToolbar.shadowRoot;
          if (!toolbarShadowRoot) {
            console.log('viewer-toolbar shadow root not found');
            return;
          }
          console.log('viewer-toolbar shadow root found:', toolbarShadowRoot);

          // Find the toolbar
          const toolbar = toolbarShadowRoot.querySelector('#toolbar');
          if (!toolbar) {
            console.log('PDF toolbar not found');
            return;
          }
          console.log('PDF toolbar found:', toolbar);

          // Find the end section of the toolbar
          const endSection = toolbar.querySelector('#end');
          if (!endSection) {
            console.log('PDF toolbar end section not found');
            return;
          }
          console.log('PDF toolbar end section found:', endSection);

          // Check if close button already exists
          if (endSection.querySelector('.pdf-close-button')) {
            console.log('Close button already exists');
            return;
          }

          // Create close button
          const closeButton = document.createElement('cr-icon-button');
          closeButton.id = 'close-button';
          closeButton.setAttribute('iron-icon', 'cr:close');
          closeButton.setAttribute('title', 'Close PDF');
          closeButton.setAttribute('aria-label', 'Close PDF');
          closeButton.className = 'pdf-close-button';
          closeButton.style.cssText = `
            color: white;
            cursor: pointer;
            margin-left: 8px;
          `;

          // Add click handler
          closeButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.closeModal(event, fileId);
          });

          // Add to toolbar
          endSection.appendChild(closeButton);
          console.log('✅ Close button added to PDF toolbar successfully!');

        } catch (error) {
          console.error(`Error in attempt ${index + 1}:`, error);
        }
      }, delay);
    });
  }

  addFallbackCloseButton(fileId) {
    // Check if toolbar close button was successfully added
    const pdfViewer = document.querySelector('pdf-viewer');
    if (!pdfViewer) return;
    
    const shadowRoot = pdfViewer.shadowRoot;
    if (!shadowRoot) return;
    
    const viewerToolbar = shadowRoot.querySelector('viewer-toolbar');
    if (!viewerToolbar) return;
    
    const toolbarShadowRoot = viewerToolbar.shadowRoot;
    if (!toolbarShadowRoot) return;
    
    const endSection = toolbarShadowRoot.querySelector('#end');
    if (!endSection) return;
    
    // Check if close button already exists in toolbar
    if (endSection.querySelector('.pdf-close-button')) {
      console.log('Toolbar close button already exists, skipping fallback');
      return;
    }
    
    // Create fallback overlay close button
    console.log('Creating fallback overlay close button');
    
    const modal = document.getElementById(`file-modal-${fileId}`);
    if (!modal) return;
    
    // Create overlay close button
    const overlayCloseButton = document.createElement('button');
    overlayCloseButton.className = 'pdf-overlay-close-button';
    overlayCloseButton.innerHTML = '&times;';
    overlayCloseButton.setAttribute('aria-label', 'Close PDF');
    overlayCloseButton.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: rgba(0, 0, 0, 0.8);
      color: white;
      border: none;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      font-size: 24px;
      font-weight: bold;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
      transition: all 0.2s ease;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    `;
    
    // Add hover effects
    overlayCloseButton.addEventListener('mouseenter', () => {
      overlayCloseButton.style.background = 'rgba(0, 0, 0, 0.9)';
      overlayCloseButton.style.transform = 'scale(1.1)';
    });
    
    overlayCloseButton.addEventListener('mouseleave', () => {
      overlayCloseButton.style.background = 'rgba(0, 0, 0, 0.8)';
      overlayCloseButton.style.transform = 'scale(1)';
    });
    
    // Add click handler
    overlayCloseButton.addEventListener('click', (event) => {
      event.stopPropagation();
      this.closeModal(event, fileId);
    });
    
    // Add to body
    document.body.appendChild(overlayCloseButton);
    console.log('✅ Fallback overlay close button added!');
    
    // Remove fallback button when modal closes
    const originalCloseModal = this.closeModal.bind(this);
    this.closeModal = (event, fileId) => {
      const fallbackButton = document.querySelector('.pdf-overlay-close-button');
      if (fallbackButton) {
        fallbackButton.remove();
      }
      originalCloseModal(event, fileId);
    };
  }

  closeModal(event, fileId) {
    // Get fileId from event target if not provided
    if (!fileId && event?.target) {
      fileId = event.target.getAttribute('data-file-id');
    }

    if (!fileId) {
      console.warn('closeModal: No fileId provided');
      return;
    }

    // Handle global modal (for templates without specific file IDs)
    let modal;
    if (fileId === 'global') {
      modal = document.getElementById('file-modal');
    } else {
      const root = event.currentTarget.closest(
        ".compact-process-view, .process"
      );

      modal = root?.querySelector(`[id="file-modal-${fileId}"]`);
    }

    if (!modal) {
      console.warn(`closeModal: Modal with id file-modal-${fileId} not found`);
      return;
    }

    if (modal._escHandler) {
      document.removeEventListener("keydown", modal._escHandler);
      delete modal._escHandler;
    }

    // Close modal if clicking on the backdrop or the close button
    if (!event || event.target === modal || event.target.classList.contains('file-modal-close') || event.target.classList.contains('text-file-close-button') || event.target.classList.contains('doc-close-button') || event.target.classList.contains('pdf-close-button') || event.target.classList.contains('pdf-iframe-close-button') || event.target.classList.contains('pdf-embed-close-button') || event.target.classList.contains('pdf-container-close-button') || event.target.classList.contains('pdf-fallback-close-button')) {
      modal.style.display = "none";
      document.body.style.overflow = "auto";

      // Clean up any remaining event listeners
      if (modal.dataset.escHandler) {
        modal.removeAttribute('data-esc-handler');
      }

      // Remove any fallback close buttons
      const fallbackButtons = document.querySelectorAll('.pdf-fallback-close-button');
      fallbackButtons.forEach(button => button.remove());
    }
  }

  readMore(event) {
    const richTextContent = event.target.closest(".block-type-description");
    const readMoreBtn = event.target;

    if (!richTextContent) return;

    const trixContent = richTextContent.querySelector(".rich-text-content");
    if (!trixContent) return;

    const readMoreText = readMoreBtn.dataset.readMore;
    const readLessText = readMoreBtn.dataset.readLess;

    if (trixContent.classList.contains("expanded")) {
      trixContent.classList.remove("expanded");
      readMoreBtn.textContent = readLessText;
    } else {
      trixContent.classList.add("expanded");
      readMoreBtn.textContent = readMoreText;
    }
  }

  updateBlockContentAfterUpload(blockId, taskId, taskListId, accountId, projectId) {
    console.log('🔄 Updating block content after upload...');
    
    const editUrl = `/${accountId}/projects/${projectId}/task_lists/${taskListId}/tasks/${taskId}/task_blocks/${blockId}/edit`;
    
    fetch(editUrl, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.js_code) {
        try {
          console.log('✅ Executing js_code from edit endpoint');
          eval(data.js_code);
        } catch (error) {
          console.error('❌ Error executing js_code:', error);
          this.manualUpdateBlockContent(taskId, taskListId);
        }
      } else {
        console.log('⚠️ No js_code in response, performing manual update');
        this.manualUpdateBlockContent(taskId, taskListId);
      }
    })
    .catch(error => {
      console.error('❌ Error fetching updated content:', error);
      this.manualUpdateBlockContent(taskId, taskListId);
    });
  }

  manualUpdateBlockContent(taskId, taskListId) {
    console.log('🔄 Performing manual block content update...');

    var containers = document.querySelectorAll(`li#task_${taskId} .tab-panel-content`);
    var container = Array.from(containers).find(el => el.offsetParent !== null);
    if (!container) {
      console.error('❌ Container not found for task', taskId);
      window.location.reload();
      return;
    }

    const taskContentUrl = `/${window.location.pathname.split('/')[1]}/projects/${window.location.pathname.split('/')[3]}/task_lists/${taskListId}/tasks/${taskId}`;

    fetch(taskContentUrl, {
      method: 'GET',
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContainer = doc.querySelector(`li#task_${taskId} .tab-panel-content`);

      if (newContainer) {
        container.innerHTML = newContainer.innerHTML;
        console.log('✅ Block content updated');

        if (window.Stimulus) {
          window.Stimulus.load();
        }

        const taskListItem = document.querySelector(`.process#task_list_${taskListId} ol.steps li#task_${taskId}`);
        const newTaskListItem = doc.querySelector(`.process#task_list_${taskListId} ol.steps li#task_${taskId}`);
        if (taskListItem && newTaskListItem) {
          taskListItem.innerHTML = newTaskListItem.innerHTML;
        }

        const animatedImg = document.querySelector(".app-nav img.animated");
        const staticImg = document.querySelector(".app-nav img.static");
        if (animatedImg) animatedImg.classList.add("hidden");
        if (staticImg) staticImg.classList.remove("hidden");
      } else {
        console.warn('⚠️ Could not find updated content, reloading page');
        window.location.reload();
      }
    })
    .catch(error => {
      console.error('❌ Error fetching task content:', error);
      window.location.reload();
    });
  }

}


function resetConfigurationForms(step_element) {
  // Hide/reset all configurations forms
  var create_configurations_divs = step_element.querySelectorAll(".create-configurations");
  for (let create_configurations_div of create_configurations_divs) {
    create_configurations_div.classList.add("hidden");
  }
  var add_first_configurations_links = step_element.querySelectorAll(".add-first-configuration");
  for (let add_first_configurations_link of add_first_configurations_links) {
    add_first_configurations_link.classList.remove("hidden");
  }
  var add_configurations_links = step_element.querySelectorAll(".add-item");
  for (let add_configurations_link of add_configurations_links) {
    add_configurations_link.classList.remove("hidden");
  }
  var edit_configurations_options_divs = step_element.querySelectorAll(".configurations-set-options.editing-configurations-options");
  for (let edit_configurations_options_div of edit_configurations_options_divs) {
    edit_configurations_options_div.classList.remove("editing-configurations-options");
    edit_configurations_options_div.classList.remove("viewing-configurations-options");
  }
  var editing_configuration_items = step_element.querySelectorAll(".configurations-list .configuration-item.configuring");
  for (let editing_configuration_item of editing_configuration_items) {
    editing_configuration_item.classList.remove("configuring");
    editing_configuration_item.querySelector(".item-content").classList.remove("hidden");
    var form = editing_configuration_item.querySelector("form");
    form.parentNode.removeChild(form);
  }
}
